module.exports = __webpack_public_path__ + "7b4086312826e3b13cf2f7a49822b25b.wav";


/*****************
 ** WEBPACK FOOTER
 ** ./dash_board/assets/sound/bell_ding.wav
 ** module id = 44
 ** module chunks = 0
 **/